
export function ISOConverter(currency?: string) {
    if (currency === undefined || currency === null)
        return "";
    if (currency.length > 3) {
        return currency.slice(0, 3);
    }
    return currency
}